import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import isLoginSidebarOpenAtom from './isLoginSidebarOpenAtom';
const useToggleIsLoginSidebarOpen = () => {
  const $ = _c(2);
  const setIsLoginSidebarOpen = useSetAtom(isLoginSidebarOpenAtom);
  let t0;
  if ($[0] !== setIsLoginSidebarOpen) {
    t0 = () => {
      setIsLoginSidebarOpen(_temp);
    };
    $[0] = setIsLoginSidebarOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleIsLoginSidebarOpen = t0;
  return toggleIsLoginSidebarOpen;
};
export default useToggleIsLoginSidebarOpen;
function _temp(isLoginSidebarOpen) {
  return !isLoginSidebarOpen;
}